export const DELIVERY_NOTE_ORDER_BY = [
  'created_on',
  'dln_date',
  'modified_on',
  'supplier_assigned_site_name',
  'supplier_name',
] as const;

export const DELIVERY_NOTE_FILTER_NAME = [
  'article_name',
  'article_number',
  'authorized_accounting_reference_id',
  'authorized_entity_type',
  'authorized_site_id',
  'billed_state',
  'buyer_id',
  'buyer_name',
  'category',
  'confirmed_accounting_reference_id',
  'confirmed_accounting_reference_name',
  'confirmed_site_id',
  'confirmed_site_name',
  'custom_field_global_level',
  'custom_field_item_level',
  'customer_number',
  'dln_accept_state',
  'dln_created_on',
  'dln_date',
  'dln_modified_on',
  'dln_nr',
  'is_mapped',
  'is_reparsed',
  'issuer_id',
  'issuer_name',
  'license_plate_number',
  'loading_location',
  'model_id',
  'ou_id',
  'ou_name',
  'process_state',
  'recipient_id',
  'recipient_name',
  'search',
  'seller_id',
  'seller_name',
  'source',
  'supplier_assigned_site_name',
  'supplier_id',
  'supplier_name',
] as const;

export const DELIVERY_NOTE_FILTER_COMPARISON_OPERATOR = [
  'contains',
  'endswith',
  'eq',
  'ge',
  'gt',
  'in',
  'le',
  'lt',
  'ne',
  'not_contains',
  'not_endswith',
  'not_startswith',
  'startswith',
] as const;
